const defFunction = `# def`
const declareFuncionInicio = `# inicio nombre funcion`
const declareFuncionFin = `# fin nombre funcion`
const declareFuncion = `${declareFuncionInicio}\n${defFunction}\n${declareFuncionFin}`;
const declareVariables = `# declaracion variables`
const codeInit = `${declareFuncion}\n${declareVariables}`
module.exports = { 
    defFunction,
    declareFuncionInicio,
    declareFuncionFin,
    declareFuncion,
    declareVariables,
    codeInit
}